import { User, Team, ActivityType, Division, Activity } from './types';

// Point System Configuration
// Points = Distance * Multiplier
export const POINTS_MULTIPLIER = {
  [ActivityType.RUN]: 1,        // 1km Run = 1 pt
  [ActivityType.RIDE]: 1 / 3,   // 3km Bike = 1 pt
  [ActivityType.SWIM]: 5        // 200m Swim = 1 pt (1km = 5 pts)
};

export const MOCK_TEAMS: Team[] = [
  { id: 't1', name: 'Chiến Thần Sale', avatar: 'https://picsum.photos/id/1/200/200', members: ['u1', 'u3'] },
  { id: 't2', name: 'Dev Bất Bại', avatar: 'https://picsum.photos/id/2/200/200', members: ['u2', 'u4'] },
  { id: 't3', name: 'HR Hủy Diệt', avatar: 'https://picsum.photos/id/3/200/200', members: ['u5'] },
];

const generateActivities = (count: number, startDate: Date): Activity[] => {
  const acts: Activity[] = [];
  for (let i = 0; i < count; i++) {
    const type = Math.random() > 0.6 ? ActivityType.RIDE : (Math.random() > 0.5 ? ActivityType.RUN : ActivityType.SWIM);
    let dist = 0;
    let duration = 0;

    if (type === ActivityType.RUN) { dist = 3 + Math.random() * 10; duration = dist * (5 + Math.random() * 2); }
    if (type === ActivityType.RIDE) { dist = 10 + Math.random() * 40; duration = dist * (2 + Math.random() * 1); }
    if (type === ActivityType.SWIM) { dist = 0.5 + Math.random() * 2; duration = dist * (20 + Math.random() * 10); }

    const points = Math.round(dist * POINTS_MULTIPLIER[type]);
    const date = new Date(startDate);
    date.setDate(date.getDate() + Math.floor(Math.random() * 14));

    acts.push({
      id: `act_${Math.random().toString(36).substr(2, 9)}`,
      type,
      distance: parseFloat(dist.toFixed(2)),
      duration: Math.round(duration),
      date: date.toISOString().split('T')[0],
      heartRate: 130 + Math.floor(Math.random() * 40),
      points,
      stravaId: `str_${Math.random()}`
    });
  }
  return acts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
};

export const MOCK_USERS: User[] = [
  {
    id: 'u1',
    name: 'Nguyễn Văn A',
    avatar: 'https://picsum.photos/id/101/200/200',
    division: Division.ADVANCED,
    teamId: 't1',
    isConnectedStrava: true,
    activities: generateActivities(12, new Date('2023-10-01'))
  },
  {
    id: 'u2',
    name: 'Trần Thị B',
    avatar: 'https://picsum.photos/id/102/200/200',
    division: Division.BASIC,
    teamId: 't2',
    isConnectedStrava: true,
    activities: generateActivities(8, new Date('2023-10-01'))
  },
  {
    id: 'u3',
    name: 'Lê Hoàng C',
    avatar: 'https://picsum.photos/id/103/200/200',
    division: Division.ADVANCED,
    teamId: 't1',
    isConnectedStrava: true,
    activities: generateActivities(15, new Date('2023-10-01'))
  },
  {
    id: 'u4',
    name: 'Phạm Minh D (Hack?)',
    avatar: 'https://picsum.photos/id/104/200/200',
    division: Division.ADVANCED,
    teamId: 't2',
    isConnectedStrava: true,
    activities: [
      ...generateActivities(5, new Date('2023-10-01')),
      { // Suspicious activity
        id: 'sus_1',
        type: ActivityType.RUN,
        distance: 42,
        duration: 60, // Marathon in 1 hour? Impossible.
        date: '2023-10-10',
        heartRate: 90,
        points: 420,
        stravaId: 'str_sus',
      }
    ]
  },
  {
    id: 'u5',
    name: 'Vũ Thu E',
    avatar: 'https://picsum.photos/id/105/200/200',
    division: Division.BASIC,
    teamId: 't3',
    isConnectedStrava: false,
    activities: []
  }
];

export const COMPETITION_START = '2023-10-01';
export const COMPETITION_END = '2023-10-31';